import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import api from '../lib/api'
import type { Comment, CommentCreateInput } from '../types/comment'

interface CommentListResponse {
  items: Comment[]
}

export function useComments(demandId: number | undefined) {
  return useQuery<Comment[]>({
    queryKey: ['comments', demandId],
    queryFn: async () => {
      const res = await api.get<CommentListResponse>(`/demands/${demandId}/comments`)
      return res.data.items
    },
    enabled: !!demandId,
  })
}

export function useCreateComment() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ demandId, body }: { demandId: number; body: CommentCreateInput }) => {
      const res = await api.post(`/demands/${demandId}/comments`, body)
      return res.data as Comment
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['comments', vars.demandId] })
    },
  })
}

export function useDeleteComment() {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: async ({ demandId, commentId }: { demandId: number; commentId: number }) => {
      await api.delete(`/demands/${demandId}/comments/${commentId}`)
    },
    onSuccess: (_data, vars) => {
      qc.invalidateQueries({ queryKey: ['comments', vars.demandId] })
    },
  })
}
